"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitle = void 0;
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Icon = require("../Icon");
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "title", "onClose", "withoutClose"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    title: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }
  };
});
var DialogTitle = exports.DialogTitle = function DialogTitle(_ref) {
  var children = _ref.children,
    title = _ref.title,
    onClose = _ref.onClose,
    _ref$withoutClose = _ref.withoutClose,
    withoutClose = _ref$withoutClose === void 0 ? false : _ref$withoutClose,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle["default"], _objectSpread(_objectSpread({
    id: 'scroll-dialog-title'
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
      container: true,
      direction: 'column',
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
        container: true,
        justifyContent: withoutClose ? 'flex-start' : 'space-between',
        alignItems: 'center',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
          item: true,
          xs: true,
          className: classes.title,
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
          children: withoutClose ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
            variant: 'outlined',
            component: 'span',
            onClick: onClose,
            edge: 'end',
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.CloseIcon, {}),
            tooltip: 'Close',
            size: "large"
          })
        })]
      })
    })
  }));
};
DialogTitle.propTypes = {
  /**
   * 	The content of the component.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  /**
   * 	Override or extend the styles applied to the component.
   *  See CSS API below for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * If true, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  withoutClose: _propTypes["default"].bool
};